// extracted by mini-css-extract-plugin
export default {"search":"search_input-module___search___aef352f7","inputWrapper":"search_input-module___inputWrapper___ae4a5b59","searchInput":"search_input-module___searchInput___f992c321"};